/**
 * Border radius tokens for the design system
 * Standardized border radius values for consistent rounded corners
 */

export const borderRadius = {
  none: '0',
  sm: '0.125rem', // 2px
  md: '0.375rem', // 6px
  lg: '0.5rem', // 8px
  xl: '0.75rem', // 12px
  '2xl': '1rem', // 16px
  '3xl': '1.5rem', // 24px
  full: '9999px', // Fully rounded
  // Component-specific border radius
  component: {
    button: '0.375rem', // 6px (md)
    input: '0.375rem', // 6px (md)
    card: '0.5rem', // 8px (lg)
    modal: '0.75rem', // 12px (xl)
    badge: '9999px', // full
    avatar: '9999px', // full
  },
} as const;

export type BorderRadius = typeof borderRadius;
